export const venueMockData = [
  {
    id: 1,
    name: "Grand Ballroom Siloam",
    location: "Lantai 5, Cempaka Putih, Jakarta",
    capacity: 500,
    type: "Indoor",
    image: "https://images.unsplash.com/photo-1519167758481-83f550bb49b3?auto=format&fit=crop&q=80&w=300",
    facilities: "WiFi, Sound System, LED Screen"
  },
  {
    id: 2,
    name: "Medical Research Hall",
    location: "Gedung B, TB Simatupang",
    capacity: 150,
    type: "Theater",
    image: "https://images.unsplash.com/photo-1431540015161-0bf868a2d407?auto=format&fit=crop&q=80&w=300",
    facilities: "AC, Projector, Mic Wireless"
  },
    {
    id: 3,
    name: "Medical Research Hall",
    location: "Gedung B, TB Simatupang",
    capacity: 150,
    type: "Theater",
    image: "https://images.unsplash.com/photo-1431540015161-0bf868a2d407?auto=format&fit=crop&q=80&w=300",
    facilities: "AC, Projector, Mic Wireless"
  },
    {
    id: 4,
    name: "Medical Research Hall",
    location: "Gedung B, TB Simatupang",
    capacity: 150,
    type: "Theater",
    image: "https://images.unsplash.com/photo-1431540015161-0bf868a2d407?auto=format&fit=crop&q=80&w=300",
    facilities: "AC, Projector, Mic Wireless"
  },
  {
    id: 5,
    name: "Medical Research Hall",
    location: "Gedung B, TB Simatupang",
    capacity: 150,
    type: "Theater",
    image: "https://images.unsplash.com/photo-1431540015161-0bf868a2d407?auto=format&fit=crop&q=80&w=300",
    facilities: "AC, Projector, Mic Wireless"
  },
  {
    id: 6,
    name: "Medical Research Hall",
    location: "Gedung B, TB Simatupang",
    capacity: 150,
    type: "Theater",
    image: "https://images.unsplash.com/photo-1431540015161-0bf868a2d407?auto=format&fit=crop&q=80&w=300",
    facilities: "AC, Projector, Mic Wireless"
  },
   {
    id: 7,
    name: "Medical Research Hall",
    location: "Gedung B, TB Simatupang",
    capacity: 150,
    type: "Theater",
    image: "https://images.unsplash.com/photo-1431540015161-0bf868a2d407?auto=format&fit=crop&q=80&w=300",
    facilities: "AC, Projector, Mic Wireless"
  }

];